export function createHiddenInput(name: string, value: string): HTMLInputElement {
  var input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", name);
  input.setAttribute("value", value);
  return input;
}
